define([
  'axios',
  'js-cookie',
  'underscore',
  'jquery',
  'es6!sumo/list/actions/Constants',
], (axios, jscookie, _, $, Constants) => {

  function _getRequestConfig() {
    return {
      withCredentials: false,
      headers: {
        'X-Sumo-Auth': jscookie.get('__smToken')
      }
    };
  }

  function _logError(error) {
    console.log('Integration error:');
    console.log(error);
  }

  function connectService(service, params) {
    return (dispatch, getState) => {
      const sumoUrl = getState().settings.get('sumoUrl');
      const siteId = getState().settings.get('siteId');

      const form = _.extend({
        site_id: siteId,
      }, params);

      dispatch(_requestConnect(service));

      return axios.post(`${sumoUrl}/oaconsumer/${service}/connect`, form, _getRequestConfig())

        .then(res => {
          if (!res.data.success) {
            throw res.data;
          }

          return dispatch(fetchServiceState())
        })

        .catch(error => {
          dispatch(_errorConnect(service, error));
          _logError(error);
        });
    }
  }

  function _errorConnect(service, error) {
    return {
      type: Constants.ERROR_CONNECT,
      service,
      error,
    };
  }

  function _requestConnect(service) {
    return {
      type: Constants.REQUEST_CONNECT,
      service,
    };
  }

  function _disconnectService(service) {
    return {
      type: Constants.DISCONNECT_SERVICE,
      service,
    };
  }

  function disconnectService(service) {
    return (dispatch, getState) => {
      const sumoUrl = getState().settings.get('sumoUrl');
      const siteId = getState().settings.get('siteId');

      return axios.post(`${sumoUrl}/oaconsumer/${service}/disconnect`, {
          site_id: siteId,
        }, _getRequestConfig())

        .then(res => {
          dispatch(_disconnectService(service));

          return dispatch(fetchServiceState())
        })

        .catch(error => {
          _logError(error);
        });
    }
  }

  function fetchServiceState() {
    return (dispatch, getState) => {
      const sumoUrl = getState().settings.get('sumoUrl');
      const siteId = getState().settings.get('siteId');

      dispatch(_requestServiceState());

      return axios.post(`${sumoUrl}/oaconsumer/state`, {
          site_id: siteId,
        }, _getRequestConfig())

        .then(res => dispatch(receiveServiceState(res.data)))

        .catch(error => {
          dispatch(_errorServiceState(error));
          _logError(error);
        });
    }
  }

  function fetchMailchimpListData(listId) {
    return (dispatch, getState) => {
      const sumoUrl = getState().settings.get('sumoUrl');
      const siteId = getState().settings.get('siteId');
      const service = 'mailchimp';

      dispatch(_requestServiceConfig('service'));

      return axios.post(`${sumoUrl}/list/${service}/check`, {
          site_id: siteId,
          list_id: listId,
        }, _getRequestConfig())

        .then(res => {
          const data = res.data;

          if (!data.success) {
            throw new Error(data.error || 'Fatal service error, please try again later or contact support');
          }

          return dispatch(_receiveAdditionalServiceConfig(service, listId, res.data));
        })

        .catch(error => {
          dispatch(_errorServiceConfig(service, error));
          _logError(error);
        });
    }
  }

  function fetchServiceConfig(service) {
    return (dispatch, getState) => {
      const sumoUrl = getState().settings.get('sumoUrl');
      const siteId = getState().settings.get('siteId');

      dispatch(_requestServiceConfig(service));

      return axios.post(`${sumoUrl}/list/${service}/lists`, {
          site_id: siteId,
        }, _getRequestConfig())

        .then(res => {
          const data = res.data;

          if (!data.success) {
            throw new Error(data.error || 'Fatal service error, please try again later or contact support');
          }

          return dispatch(_receiveServiceConfig(service, res.data));
        })

        .catch(error => {
          dispatch(_errorServiceConfig(service, error));
          _logError(error);
        });
    }
  }

  function _requestServiceConfig(service) {
    return {
      type: Constants.REQUEST_SERVICE_CONFIG,
      service: service,
    };
  }

  function _receiveExactTargetFields(service, extensionId, config) {
    return {
      type: Constants.RECEIVE_EXACTTARGET_FIELDS,
      extensionId,
      config,
    };
  }

  function _receiveAdditionalServiceConfig(service, listId, config) {
    return {
      type: Constants.RECEIVE_ADDITIONAL_SERVICE_CONFIG,
      service,
      listId,
      config,
    };
  }

  function _receiveServiceConfig(service, config) {
    return {
      type: Constants.RECEIVE_SERVICE_CONFIG,
      service,
      config,
    };
  }

  function _errorServiceConfig(service, error) {
    return {
      type: Constants.ERROR_SERVICE_CONFIG,
      service: service,
      error: _.isString(error) ? error : (error.hasOwnProperty('message') ? error.message : error + ''),
    };
  }

  function _requestServiceState() {
    return {
      type: Constants.REQUEST_SERVICE_STATE,
    };
  }

  function receiveServiceState(serviceState) {
    return {
      type: Constants.RECEIVE_SERVICE_STATE,
      ...serviceState,
    };
  }

  function _errorServiceState(error) {
    return {
      type: Constants.ERROR_SERVICE_STATE,
      error: error,
    };
  }

  function _saveServiceSettings(service, objectId) {
    return {
      type: Constants.SAVE_SERVICE_SETTINGS,
      service,
      objectId,
    }
  }

  function fetchExactTargetFields(objectId, extensionId) {
    return (dispatch, getState) => {
      const sumoUrl = getState().settings.get('sumoUrl');
      const siteId = getState().settings.get('siteId');

      return axios.post(`${sumoUrl}/list/exacttarget/datafields`, {
        site_id: siteId,
        extension_id: extensionId,
      }, _getRequestConfig())

        .then(res => {
          const data = res.data;

          if (!data.success) {
            return Promise.resolve();
          }

          return dispatch(_receiveExactTargetFields(objectId, extensionId, _.omit(data, 'success')));
        })

        .catch(error => {
          _logError(error);
        });
    }
  }

  function validateFormSyncSnippet(objectId, snippet) {
    return (dispatch, getState) => {
      const sumoUrl = getState().settings.get('sumoUrl');
      const siteId = getState().settings.get('siteId');

      return axios.post(`${sumoUrl}/sumolist/formsync/validate`, {
        site_id: siteId,
        html: snippet,
      }, _getRequestConfig())

        .then(res => {
          const data = res.data;

          if (!data.success) {
            return Promise.resolve();
          }

          return Promise.all([
          ]).then(res => dispatch(_receiveFormSyncSettings(objectId, _.omit(data, 'success'))));
        })

        .catch(error => {
          _logError(error);
        });
    }
  }

  function testServiceSettings(service, settings, emailAddress, objectId, successMessage, errorMessage) {
    return (dispatch, getState) => {
      const sumoUrl = getState().settings.get('sumoUrl');
      const siteId = getState().settings.get('siteId');

      // Set "loading" to true
      if (service && objectId) {
        dispatch(_saveServiceSettings(service, objectId));
      }

      return axios.post(`${sumoUrl}/list/${service}/test`, {
        site_id: siteId,
        email: emailAddress,
        ...settings,
      }, _getRequestConfig())

        .then(res => {
          const data = res.data;

          // Delete the stored settings after value is saved
          if (service && objectId) {
            dispatch(removeObjectSettings(objectId, service))
          }

          if (!data.success) {
            return Promise.reject(new Error(data.error));
          }

          if (successMessage) {
            $.growlUI(successMessage, null, 2e3);
          }

          return Promise.resolve();
        })

        .catch(error => {
          if (errorMessage) {
            $.growlUI(errorMessage, null, 2e3);
          } else {
            _logError(error);
          }
          return Promise.reject(error);
        });
    }
  }

  function saveServiceSettings(appId, service, objectId, settings, successMessage, errorMessage) {
    return (dispatch, getState) => {
      const sumoUrl = getState().settings.get('sumoUrl');
      const siteId = getState().settings.get('siteId');

      // Set latest settings on state
      dispatch(updateServiceSettings(service, objectId, settings));

      // Set "loading" to true
      dispatch(_saveServiceSettings(service, objectId));

      return axios.post(`${sumoUrl}/list/${service}/settings/save`, _.extend({
        site_id: siteId,
        object_id: objectId,
        app_id: appId,
      }, settings), _getRequestConfig())

        .then(res => {
          const data = res.data;

          if (!data.success) {
            return Promise.resolve();
          }

          // Return if objectId is 'events', because it contains webhook settings
          if (successMessage) {
            $.growlUI(successMessage, null, 2e3);
          }

          // Delete the stored settings after value is saved (to clear the Integration's Mask UI)
          return Promise.all([dispatch(removeObjectSettings(objectId, service))])
        })
        .catch(error => {
          // Return if objectId is 'events', because it contains webhook settings
          if (errorMessage) {
            $.growlUI(errorMessage, null, 2e3);
          } else {
            _logError(error);
          }

          return Promise.all([dispatch(removeObjectSettings(objectId, service))])
        });
    }
  }

  function saveAllServiceSettings(appId, objectId) {
    return (dispatch, getState) => {
      const sumoUrl = getState().settings.get('sumoUrl');
      const siteId = getState().settings.get('siteId');
      const services = getState().services.get('byObjectId').get(objectId);

      if (!services) return Promise.resolve();

      const settings = services.toJS();

      return axios.post(`${sumoUrl}/list/settings/save`, {
          site_id: siteId,
          object_id: objectId,
          app_id: appId,
          settings: settings,
        }, _getRequestConfig())

        .then(res => {
          const data = res.data;

          if (!data.success) {
            return Promise.resolve();
          }

          return Promise.all([
            dispatch(removeObjectSettings(objectId))
          ]).then(() => settings)
        })

        .catch(error => {
          _logError(error);
        });
    }
  }

  function updateSetting(setting, value) {
    return {
      type: Constants.UPDATE_INTEGRATION_SETTING,
      setting,
      value,
    };
  }

  function updateServiceSettings(service, objectId, settings) {
    return {
      type: Constants.UPDATE_SERVICE_SETTINGS,
      service,
      objectId,
      settings,
    };
  }

  function _receiveFormSyncSettings(objectId, settings) {
    return {
      type: Constants.RECEIVE_FORMSYNC_SETTINGS,
      objectId,
      settings,
    }
  }

  function _requestServiceSettings(service, objectId) {
    return {
      type: Constants.REQUEST_SERVICE_SETTINGS,
      service,
      objectId
    };
  }

  function _receiveServiceSettings(service, objectId, settings) {
    return {
      type: Constants.RECEIVE_SERVICE_SETTINGS,
      service,
      objectId,
      settings,
    };
  }

  function removeObjectSettings(objectId, service) {
    return {
      type: Constants.REMOVE_SERVICE_SETTINGS,
      objectId,
      service,
    };
  }

  function updateIntegrationFilter(filter) {
    return {
      type: Constants.UPDATE_INTEGRATION_FILTER,
      filter,
    }
  }

  function _errorServiceSettings(error) {
    return {
      type: Constants.ERROR_SERVICE_SETTINGS,
      error: _.isString(error) ? error : (error.hasOwnProperty('message') ? error.message : error + ''),
    };
  }

  function fetchServiceSettings(appId, service, objectId) {
    return (dispatch, getState) => {
      const sumoUrl = getState().settings.get('sumoUrl');
      const siteId = getState().settings.get('siteId');

      dispatch(_requestServiceSettings(service, objectId));

      axios.post(`${sumoUrl}/list/${service}/settings/load`, {
          site_id: siteId,
          app_id: appId,
          object_id: objectId,
        }, _getRequestConfig())

        .then(res => {
          const data = res.data;

          if (!data.success) {
            throw new Error(data.error || 'Fatal service error, please try again later or contact support');
          }

          return dispatch(_receiveServiceSettings(service, objectId, res.data));
        })

        .catch(error => {
          dispatch(_errorServiceSettings(error));
          _logError(error);
        });
    };
  }

  function generateApiKey() {
    return (dispatch, getState) => {
      const sumoUrl = getState().settings.get('sumoUrl');
      const siteId = getState().settings.get('siteId');

      axios.post(`${sumoUrl}/api/generate_key`, {
        site_id: siteId,
      }, _getRequestConfig()).then((response) => {
        const { data } = response;
        if (!data.success) throw new Error(data.error || 'Error generating Sumo API Key');
        dispatch(updateSetting('sumoApiKey', data.sumoApiKey));
      });
    };
  }

  return {
    fetchServiceState,
    fetchServiceConfig,
    fetchMailchimpListData,
    fetchServiceSettings,
    removeObjectSettings,
    connectService,
    disconnectService,
    updateServiceSettings,
    saveServiceSettings,
    saveAllServiceSettings,
    validateFormSyncSnippet,
    testServiceSettings,
    updateIntegrationFilter,
    fetchExactTargetFields,
    generateApiKey,
  };
});
